import { render, staticRenderFns } from "./order-card.vue?vue&type=template&id=d1f4b348&scoped=true&"
import script from "./order-card.vue?vue&type=script&lang=js&"
export * from "./order-card.vue?vue&type=script&lang=js&"
import style0 from "./order-card.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./order-card.vue?vue&type=style&index=1&id=d1f4b348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f4b348",
  null
  
)

export default component.exports